var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 130,
    viewBox: "0 0 180 140",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03 0 0 -0.03 90.55 66.95)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(83,170,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-2560, -2562.53)",
    d: "M 642 4474 c -56 -28 -90 -65 -119 -130 c -17 -37 -18 -119 -21 -1382 l -2 -1343 l -216 -237 c -119 -130 -225 -255 -237 -277 c -33 -62 -30 -164 6 -230 c 61 -111 123 -190 172 -220 l 48 -30 l 2287 0 l 2287 0 l 48 30 c 49 30 111 109 172 220 c 36 66 39 168 6 230 c -12 22 -118 147 -237 277 l -216 237 l -2 1343 l -3 1343 l -28 57 c -15 31 -43 68 -62 83 c -78 59 61 55 -1968 55 l -1863 0 l -52 -26 z m 3783 -159 l 25 -24 l 0 -1066 l 0 -1065 l -1890 0 l -1890 0 l 0 1065 l 0 1066 l 25 24 l 24 25 l 1841 0 l 1841 0 l 24 -25 z m 25 -2475 l 0 -160 l -1890 0 l -1890 0 l 0 160 l 0 160 l 1890 0 l 1890 0 l 0 -160 z m 170 -457 l 124 -138 l -1092 -3 c -601 -1 -1583 -1 -2184 0 l -1092 3 l 124 138 l 125 137 l 1935 0 l 1935 0 l 125 -137 z m -3023 -451 c 57 -79 103 -145 103 -148 c 0 -10 -1372 -4 -1391 7 c -21 11 -113 145 -124 180 c -10 29 2 65 27 89 c 22 20 30 20 652 18 l 629 -3 l 104 -143 z m 1826 136 c -5 -7 -54 -75 -108 -150 l -98 -138 l -657 0 l -657 0 l -98 138 c -54 75 -103 143 -108 150 c -8 9 167 12 863 12 c 696 0 871 -3 863 -12 z m 1484 -8 c 26 -24 37 -54 29 -84 c -9 -34 -102 -173 -125 -185 c -19 -11 -1391 -17 -1391 -6 c 0 4 119 171 187 263 l 24 32 l 628 0 c 610 0 628 -1 648 -20 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbook);
export default __webpack_public_path__ + "static/media/netbook.06b99ef7c9ca0c139581c0211be9fa9b.svg";
export { ForwardRef as ReactComponent };